import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { SezioneScadenze } from 'src/app/common/models/sezioni/sezione-scadenze';
import { DettaglioAdempimento } from 'src/app/common/models/dettaglio-adempimento';
import { DettaglioAdempimentoForm } from 'src/app/common/form/dettaglio-adempimento-form';
import { SezioneDettaglioAdempimentoResponse } from 'src/app/common/models/dto/sezione-dettaglio-adempimento-response';
import { FormValidationService } from 'src/app/common/services/form-validation.service';


@Component({
  selector: 'div [dettaglio-adempimento-form]',
  templateUrl: '../../../form/dettaglio-adempimento-form.html'
})

export class DettaglioAdempimentoComponent extends DettaglioAdempimentoForm implements OnInit {
  sezione: SezioneScadenze;
  dettaglioAdempimento: DettaglioAdempimento;
  urlUpdate: string;
  idScadenza: string;

  @Output() onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService,
              protected formValidationService: FormValidationService,){
    super(operationService, campiForm, helpers, modalNotifyService, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Dettaglio adempimento');
  }  

  inizializza(sezione: SezioneScadenze,idScadenza:string,urlUpdate: string, fascicolo: FascicoloFull, inserimento: boolean, dettaglio?: DettaglioAdempimento) {
    this.fascicolo = fascicolo;
    this.sezione = sezione;
    this.idScadenza = idScadenza
    this.urlUpdate = urlUpdate;
    this.inserimento=inserimento;
    if (!this.inserimento && dettaglio) {
      this.dettaglioAdempimento = dettaglio;
    } else {
      this.dettaglioAdempimento = new DettaglioAdempimento();
    }
    this.createForm();
    this.populateSelect();
  }

  getRequest(request: DettaglioAdempimento) { 
    const idScadenza = this.idScadenza;
    const urlWithId = `${this.urlUpdate.replace("{entityId}", idScadenza)}`;
    if(this.inserimento) {
      this.operationService.addDettaglioAdempimento(urlWithId, request).subscribe((response: any) => this.dati(response));
    } else {
      request.id = this.dettaglioAdempimento.id;
      this.operationService.updateDettaglioAdempimento(urlWithId, request).subscribe((response:any)=>this.dati(response));
    }
  }

  dati(response: SezioneDettaglioAdempimentoResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  getDettaglioAdempimento(): DettaglioAdempimento {
      return this.dettaglioAdempimento;
  }

}
